export enum SiteEnum {
    Naturfagsmaraton = 1,
    Sciencedysten = 2
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/SiteEnum.ts